import React, { useContext, useState } from 'react';

export interface User {
  email: string;
}

interface AuthContextProps {
  user?: User;
  setUser: (newUser: User) => void;
}

const AuthContext = React.createContext<AuthContextProps | undefined>(undefined);

const getCookie = cookieName => {
  const name = cookieName + '=';
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return '';
};

const decodePayload = cookieValue =>
  JSON.parse(atob(cookieValue.split('.')[1]))

const loadUser = (): User | undefined => {
  const cookie = getCookie('zzm-ci');
  if (cookie) {
    const { user } = decodePayload(cookie);
    return user;
  }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState<User | undefined>(loadUser);
  return <AuthContext.Provider value={{ user, setUser }}>
    {children}
  </AuthContext.Provider>
};

export const useAuthentication = (): AuthContextProps => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('Context not found!');
  }
  return context;
}

export const useAuthUser = (): User | undefined => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('Context not found!');
  }
  return context.user;
}
